import ow from 'ow';

const AUTOFOCUS_MAX_ITERATIONS = 500;
const AUTOFOCUS_TIMEOUT = 100;

export default class Autofocuser {
  constructor(inputSelectors) {
    ow(inputSelectors, 'inputSelectors', ow.object.nonEmpty);
    this.inputSelectors = inputSelectors;
  }

  getAutofocusElements(inputType) {
    return [inputType] in this.inputSelectors
      ? this.inputSelectors[inputType]()
      : [];
  }

  isVisible(style) {
    return style.visibility === 'visible' && style.display !== 'hidden';
  }

  start(inputType) {
    const isVisibleCallback = (type, iteration) => {
      let nextIteration = iteration;
      let els = this.getAutofocusElements(type);
      let focused = false;
      els.forEach((el) => {
        if (this.isVisible(getComputedStyle(el))) {
          el.focus();
          el.select();
          focused = true;
        }
      });
      if (!focused && nextIteration++ < AUTOFOCUS_MAX_ITERATIONS) {
        setTimeout(
          () => isVisibleCallback(type, nextIteration),
          AUTOFOCUS_TIMEOUT
        );
      }
    };
    isVisibleCallback(inputType, 0);
  }
}
